<!--eslint-disable-->
<template>
  <div class="sun-three">
    <div class="slider-wrapper">
      <div class="slider-wrapper-cameraPosition">
        <p>调整相机透视距离</p>
        <div class="slider-block">
          <span class="slider-block-label">透视距离:</span>
          <el-slider v-model="cameraDistance" :min="10" :max="200" :step="10" show-input
                     @change="changeCameraDistance"></el-slider>
        </div>
      </div>
      <div class="slider-wrapper-cubeSize">
        <p>调整长方体尺寸</p>
        <div class="slider-block">
          <span class="slider-block-label">Width:</span>
          <el-slider v-model="cubeSize.width" :min="1" :max="100" :step=".1" show-input
                     @change="changeWidth"></el-slider>
        </div>
        <div class="slider-block">
          <span class="slider-block-label">Height:</span>
          <el-slider v-model="cubeSize.height" :min="1" :max="100" :step=".1" show-input
                     @change="changeHeight"></el-slider>
        </div>
        <div class="slider-block">
          <span class="slider-block-label">Depth:</span>
          <el-slider v-model="cubeSize.depth" :min="1" :max="100" :step=".1" show-input
                     @change="changeDepth"></el-slider>
        </div>
      </div>
      <div class="slider-wrapper-cameraPosition">
        <p>调整相机位置</p>
        <!--相机位置调整-->
        <div class="slider-block">
          <span class="slider-block-label">X轴:</span>
          <el-slider v-model="cameraPosition.x" :min="-100" :max="100" :step="1" show-input
                     @change="changePositionx"></el-slider>
        </div>
        <div class="slider-block">
          <span class="slider-block-label">Y轴:</span>
          <el-slider v-model="cameraPosition.y" :min="-100" :max="100" :step="1" show-input
                     @change="changePositiony"></el-slider>
        </div>
        <div class="slider-block">
          <span class="slider-block-label">Z轴:</span>
          <el-slider v-model="cameraPosition.z" :min="-100" :max="100" :step="1" show-input
                     @change="changePositionz"></el-slider>
        </div>
      </div>

    </div>
    <div id="canvasWrapper" ref="canvasWrapper"></div>
    <div class="color-picker">
      <el-color-picker v-model="cubeColor" @change="changeCubeColor"></el-color-picker>
      <!--      背景色-->
      <el-color-picker v-model="backgroundColor" @change="changeBackgroundColor"></el-color-picker>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'

export default {
  data() {
    return {
      cubeSize: {
        width: 26,
        height: 17.3,
        depth: 22.5
      }, // 长方体的长宽高
      // 相机位置
      cameraPosition: {
        x: 43,
        y: 18,
        z: 33
      },
      // 相机距离
      cameraDistance: 150,
      // 长方体颜色值
      cubeColor: '#43AF37',
      backgroundColor: '#000000',
      isMobile: false,
      rendererHeight: 400
    }
  },
  created() {
    this.isMobile = this.isMobileDevice()
  },
  mounted() {
    this.initThree()
    this.createCube()
    this.renderScene()
  },
  methods: {
    isMobileDevice() {
      const ua = navigator.userAgent
      const ipad = ua.match(/(iPad).*OS\s([\d_]+)/)
      const isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/)
      const isAndroid = ua.match(/(Android)\s+([\d.]+)/)
      return isIphone || isAndroid
    },
    changeBackgroundColor() {
      this.clearCanvasWrapper()
      this.initThree()
      this.createCube()
      this.renderScene()
    },
    changeCubeColor() {
      this.clearCanvasWrapper()
      this.initThree()
      this.createCube()
      this.renderScene()
    },
    changeCameraDistance() {
      this.clearCanvasWrapper()
      this.initThree()
      this.createCube()
      this.renderScene()
    },
    changeWidth() {
      this.clearCanvasWrapper()
      this.initThree()
      this.createCube()
      this.renderScene()
    },
    changeHeight() {
      this.clearCanvasWrapper()
      this.initThree()
      this.createCube()
      this.renderScene()
    },
    changeDepth() {
      this.clearCanvasWrapper()
      this.initThree()
      this.createCube()
      this.renderScene()
    },
    changePositionx() {
      this.clearCanvasWrapper()
      this.initThree()
      this.createCube()
      this.renderScene()
    },
    changePositiony() {
      this.clearCanvasWrapper()
      this.initThree()
      this.createCube()
      this.renderScene()
    },
    changePositionz() {
      this.clearCanvasWrapper()
      this.initThree()
      this.createCube()
      this.renderScene()
    },
    // 清空canvasWrapper
    clearCanvasWrapper() {
      this.$refs.canvasWrapper.innerHTML = ''
    },
    initThree() {
      // 创建场景
      const scene = new THREE.Scene()
      // 设置背景色
      scene.background = new THREE.Color(this.backgroundColor)
      // 创建透视相机
      const camera = new THREE.PerspectiveCamera(this.cameraDistance, window.innerWidth / window.innerHeight, 0.1, 1000)
      // 设置相机位置
      camera.position.set(this.cameraPosition.x, this.cameraPosition.y, this.cameraPosition.z)

      // 创建渲染器
      const renderer = new THREE.WebGLRenderer({ antialias: true })
      this.rendererHeight = this.isMobile ? 600 : 400
      renderer.setSize(window.innerWidth, this.rendererHeight)

      // 将渲染器添加到DOM中
      this.$refs.canvasWrapper.append(renderer.domElement)

      // 创建长方体
      var cubeSize = this.cubeSize // 调整长宽高
      const geometry = new THREE.BoxGeometry(cubeSize.width, cubeSize.height, cubeSize.depth)
      // 灰紫色的长方体
      const material = new THREE.MeshBasicMaterial({ color: this.cubeColor })
      const cube = new THREE.Mesh(geometry, material)

      // 创建边缘材质
      var edges = new THREE.EdgesGeometry(geometry)
      var line = new THREE.LineSegments(edges, new THREE.LineBasicMaterial({ color: 0x000000 }))

      // 将长方体和边缘线添加到场景
      scene.add(line)

      scene.add(cube)

      // 添加光源
      var light = new THREE.PointLight(0xFFFFFF)
      light.position.set(10, 10, 10)
      scene.add(light)

      // 渲染场景
      renderer.render(scene, camera)
    },
    createCube() {
      // 仅用于演示，在实际项目中可以添加更多功能
    },
    renderScene() {
      // 仅用于演示，在实际项目中可以添加更多功能
    }
  }
}
</script>

<style>
.sun-three {
  width: 100%;
  padding-bottom: 100px;
}

.sun-three canvas {
  max-width: 100%;
  height: 100%;
}

#canvasWrapper {
  width: 100%;
}

.slider-wrapper-cubeSize {
  margin: 10px 0;
  width: 30%;
}

.slider-wrapper-cubeSize p {
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}

.slider-wrapper-cameraPosition {
  margin: 10px 0;
  width: 30%;
}

.slider-wrapper-cameraPosition p {
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}

.slider-block .el-slider {
  width: 90%;
}

.slider-block {
  display: flex;
  align-items: center;
}

.slider-block .el-slider {
  margin-left: 12px;
}

.slider-block .slider-block-label {
  display: flex;
  align-items: center;
  width: max-content;
  text-align: center;
  word-break: keep-all;
}

.slider-wrapper {
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-slider {
  margin: 0;
}

.el-slider__runway.show-input {
  width: 60%;
  min-width: 100px;
}

.color-picker {
  text-align: center;
}

@media screen and (max-width: 768px) {
  .slider-wrapper {
    flex-direction: column;
  }

  .slider-wrapper-cubeSize {
    width: 100%;
  }

  .slider-wrapper-cameraPosition {
    width: 100%;
  }

  .slider-wrapper-cubeSize p, .slider-wrapper-cameraPosition p, .slider-block .slider-block-label {
    font-size: 12px;
  }
}

</style>
